import React from 'react'
import { GetServerSideProps, NextPage } from 'next/types'
import { PageProps } from '@/core/types'
import { getDomainLocale } from '@/core/utils/appConfig'

const EN_ERROR = 'Service Unavailable'
const ES_ERROR = 'Servicio no disponible'

const message: Record<string, string> = {
  de_DE: 'Dienst nicht verfügbar',
  en_BE: EN_ERROR,
  en_CA: EN_ERROR,
  en_DE: EN_ERROR,
  en_ES: EN_ERROR,
  en_GB: EN_ERROR,
  en_GH: EN_ERROR,
  en_MY: EN_ERROR,
  en_NL: EN_ERROR,
  en_PH: EN_ERROR,
  en_TZ: EN_ERROR,
  en_UG: EN_ERROR,
  en_US: EN_ERROR,
  en_VN: EN_ERROR,
  en_ZA: EN_ERROR,
  es_AR: ES_ERROR,
  es_BO: ES_ERROR,
  es_CL: ES_ERROR,
  es_CO: ES_ERROR,
  es_DO: ES_ERROR,
  es_EC: ES_ERROR,
  es_ES: ES_ERROR,
  es_HN: ES_ERROR,
  es_MX: ES_ERROR,
  es_PA: ES_ERROR,
  es_PE: ES_ERROR,
  es_PY: ES_ERROR,
  es_SV: ES_ERROR,
  es_US: ES_ERROR,
  es_UY: ES_ERROR,
  fil_PH: 'Serbisyo ay hindi magagamit',
  fr_BE: 'Service non disponible',
  fr_CA: 'Service non disponible',
  id_ID: 'Layanan Tidak Tersedia',
  ko_KR: '서비스를 사용할 수 없습니다',
  ms_MY: 'Perkhidmatan Tidak Tersedia',
  nl_BE: 'Dienst niet beschikbaar',
  nl_NL: 'Dienst niet beschikbaar',
  pt_BR: 'Serviço indisponível',
  sw_TZ: 'Huduma haipatikani',
  sw_UG: 'Huduma haipatikani',
  th_TH: 'บริการไม่สามารถใช้งานได้',
  vi_VN: 'Dịch vụ không khả dụng.',
  zh_AR: '无法提供服务',
  zh_MY: '无法提供服务',
  zh_PA: '无法提供服务',
  zh_ZA: '无法提供服务'
}

interface ErrorPageProps extends Partial<PageProps> {
  errorMessage: string
}

const ServiceUnavailablePage: NextPage<ErrorPageProps> = ({ errorMessage }) => {
  return (
    <>
      <div className="page-container">
        <div
          style={{
            height: '80px',
            background: '#ffff00',
            marginBottom: 20
          }}
        ></div>
        <div className="bees-grid is-margin-top-m is-margin-bottom-m">
          <div className="bees-col is-4-col-phone is-8-col-tablet is-12-col-desktop">
            <h1 className="bees-heading is-text-align-left is-margin-bottom-s">
              {errorMessage}
            </h1>
          </div>
        </div>
      </div>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<ErrorPageProps> = async (
  context
  // eslint-disable-next-line require-await
) => {
  const { isSupported, locale } = getDomainLocale(context)

  return {
    props: {
      pathname: '/service_unavailable',
      errorMessage: (isSupported && message[locale]) || EN_ERROR,
      pageKey: 'SERVICE_UNAVAILABLE'
    }
  }
}

export default ServiceUnavailablePage
